import { getNode, isCustomNodeAllowed, setActiveTool } from "../../../commands/custom-commands";
import { deleteColumn, addColumnBefore, addColumnAfter } from "prosemirror-tables";
import { customSchema } from "../../../schemas/custom-schema";

export default class TableColumnsTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container has-disabled--hidden";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName = "--table-columns-anchor";
    this.buttonElement.dataset.action = "table-columns";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Columnas";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Columnas";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Columnas";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor ="--table-columns-anchor";
    this.addLeftButton = document.createElement("button");
    this.addLeftButton.setAttribute("type", "button");
    this.addLeftButton.className = "editor-button";
    this.addLeftButton.textContent = "Añadir a la izquierda";

    this.addRightButton = document.createElement("button");
    this.addRightButton.setAttribute("type", "button");
    this.addRightButton.className = "editor-button";
    this.addRightButton.textContent = "Añadir a la derecha";

    this.removeButton = document.createElement("button");
    this.removeButton.type = "button";
    this.removeButton.className = "editor-button";
    this.removeButton.textContent = "Remover";

    this.dialogElement.appendChild(this.addLeftButton);
    this.dialogElement.appendChild(this.addRightButton);
    this.dialogElement.appendChild(this.removeButton);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.removeAction = this.removeButtonClickCallback();
    this.addLeftAction = this.addLeftButtonClickCallback();
    this.addRightAction = this.addRightButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.addLeftButton.addEventListener("click", this.addLeftAction);
    this.addRightButton.addEventListener("click", this.addRightAction);
    this.removeButton.addEventListener("click", this.removeAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.table);
    if(!!node) {
      this.buttonElement.removeAttribute("disabled");
      this.addLeftButton.removeAttribute("disabled");
      this.addRightButton.removeAttribute("disabled");
      this.removeButton.removeAttribute("disabled");
    } else {
      this.buttonElement.setAttribute("disabled", "");
      this.addLeftButton.setAttribute("disabled", "");
      this.addRightButton.setAttribute("disabled", "");
      this.removeButton.setAttribute("disabled", "");
    }
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.removeButton.removeEventListener("click", this.removeAction);
    this.addLeftButton.removeEventListener("submit", this.addLeftAction);
    this.addRightButton.removeEventListener("submit", this.addRightAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.addLeftButton = null;
    this.addRightButton = null;
    this.removeButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.addLeftAction = null;
    this.addRightAction = null;
    this.removeAction = null;
  }

  removeButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }
      
      deleteColumn(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.view.state, this.view.dispatch);
    }
  }

  addLeftButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      addColumnBefore(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }

  addRightButtonClickCallback() {
    return () => {
      const isActive = getNode(this.view.state, customSchema.nodes.table);
      if(!isActive) {
        return false;
      }

      addColumnAfter(this.view.state, this.view.dispatch);
      setActiveTool(null)(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}